import { render, staticRenderFns } from "./basicUsersTable.vue?vue&type=template&id=e94cdf48&scoped=true&"
import script from "./basicUsersTable.vue?vue&type=script&lang=js&"
export * from "./basicUsersTable.vue?vue&type=script&lang=js&"
import style0 from "./basicUsersTable.vue?vue&type=style&index=0&id=e94cdf48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94cdf48",
  null
  
)

export default component.exports